var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tagName,{tag:"component",class:[
    'no-underline',
    'cursor-pointer',
    'select-none',
    'transition',
    'focus:outline-none',
    _vm.shouldFixHeight && _vm.heightSizeClass,
    _vm.borderRadiusClass,
    'border-none',
    'flex',
    'items-center',
    'justify-center',
    _vm.fontSizeClass,
    _vm.fontWeightClass,
    'font-sans',
    'hover-hover:disabled:cursor-not-allowed',
    'whitespace-nowrap' ].concat( (_vm.hasIconOnly ? [_vm.widthSizeClass, _vm.shouldFixHeight && _vm.heightSizeClass, 'inline-flex'] : []),
    (_vm.hasIconAndText ? ['pl-4', 'pr-2'] : []),
    (!_vm.isCustomButton && _vm.isColorPrimary && !_vm.isTextButton
      ? [
          'bg-padlet-pink',
          'text-light-text-100',

          // Hover + Active + Focus
          'hover-hover:hover:bg-padlet-pink-600',
          'hover-hover:active:bg-padlet-pink-600',
          'hover-hover:focus:bg-padlet-pink-600',
          'hover-hover:dark:hover:bg-padlet-pink-400',
          'hover-hover:dark:active:bg-padlet-pink-400',
          'hover-hover:dark:focus:bg-padlet-pink-400',

          // Disabled
          'hover-hover:disabled:bg-padlet-pink-100',
          'hover-hover:dark:disabled:bg-padlet-pink-900',
          'hover-hover:disabled:text-light-text-200',
          'hover-hover:dark:disabled:text-light-text-400' ]
      : []),

    (!_vm.isCustomButton && _vm.isColorPulsingPrimary && !_vm.isTextButton
      ? [
          'bg-padlet-pink',
          'text-light-text-100',

          // Hover
          'hover-hover:hover:animate-pulse-bg-color',
          'pulse-bg-from-padlet-pink-500',
          'pulse-bg-to-grape-500',
          'dark:pulse-bg-to-canary-500',

          // Active
          'hover-hover:active:animate-none',
          'active:bg-grape-500',
          'dark:active:bg-canary-500',

          // Focus
          'hover-hover:focus:animate-none',
          'focus:bg-grape-500',
          'dark:focus:bg-canary-500',

          // Disabled
          'hover-hover:disabled:animate-none',
          'hover-hover:disabled:bg-padlet-pink-100',
          'hover-hover:dark:disabled:bg-padlet-pink-900',
          'hover-hover:disabled:text-light-text-200',
          'hover-hover:dark:disabled:text-light-text-400' ]
      : []),
    (!_vm.isCustomButton && _vm.isColorSecondary && !_vm.isTextButton
      ? [
          _vm.xLessProminentBackground ? 'bg-light-ui-150' : 'bg-light-ui-300',
          _vm.xLessProminentBackground ? 'dark:bg-dark-ui-150' : 'dark:bg-dark-ui-300',
          'text-dark-text-200',
          'dark:text-light-text-200',

          // Hover
          'hover-hover:hover:bg-light-ui-500',
          'hover-hover:dark:hover:bg-dark-ui-500',

          // Focus
          'hover-hover:focus:bg-light-ui-500',
          'hover-hover:dark:focus:bg-dark-ui-500',
          'hover-hover:focus:text-dark-text-100',
          'hover-hover:dark:focus:text-light-text-100',

          // Active
          'hover-hover:active:bg-grape-500',
          'hover-hover:dark:active:bg-canary-500',
          'hover-hover:active:text-light-text-100',
          'hover-hover:dark:active:text-dark-text-100',

          // Disabled
          'disabled:bg-transparent',
          'dark:disabled:bg-transparent',
          'disabled:text-dark-text-400',
          'dark:disabled:text-light-text-400',
          'hover-hover:disabled:bg-transparent',
          'hover-hover:dark:disabled:bg-transparent',
          'hover-hover:disabled:text-dark-text-400',
          'hover-hover:dark:disabled:text-light-text-400' ]
      : []),
    (_vm.isColorDanger && !_vm.isTextButton
      ? [
          'bg-danger-100',
          'text-white-100',

          // Hover + Active + Focus
          'hover-hover:hover:bg-scarlet-700',
          'hover-hover:focus:bg-scarlet-700',
          'hover-hover:active:bg-scarlet-700',

          // Disabled
          'hover-hover:disabled:bg-scarlet-700',
          'hover-hover:disabled:text-white-200' ]
      : []),
    (_vm.isColorDanger && !_vm.isTextButton
      ? [
          'bg-danger-100',
          'text-white-100',

          // Hover + Active + Focus
          'hover-hover:hover:bg-scarlet-700',
          'hover-hover:focus:bg-scarlet-700',
          'hover-hover:active:bg-scarlet-700',

          // Disabled
          'hover-hover:disabled:bg-scarlet-700',
          'hover-hover:disabled:text-white-200' ]
      : []),
    (!_vm.isCustomButton && _vm.isColorActive && !_vm.isTextButton
      ? ['font-semibold', 'bg-grape-500', 'dark:bg-canary-500', 'text-white-100', 'dark:text-highway-100']
      : []),
    (!_vm.isCustomButton && _vm.isTextButton
      ? [
          'bg-transparent' ].concat( (_vm.isColorPrimary
            ? [
                'text-padlet-pink',
                'hover-hover:hover:text-padlet-pink-800',
                'hover-hover:active:text-padlet-pink-800',
                'hover-hover:focus:text-padlet-pink-800',
                // Disabled
                'hover-hover:disabled:text-padlet-pink-100',
                'hover-hover:dark:disabled:text-padlet-pink-100' ]
            : []),
          (_vm.isColorSecondary
            ? [
                { 'text-dark-text-200': _vm.isBrowserDecidingDarkMode || _vm.isForcedLight },
                { 'dark:text-light-text-200': _vm.isBrowserDecidingDarkMode },
                { 'text-light-text-200': _vm.isForcedDark },
                // Hover
                { 'hover-hover:hover:text-grape-500': _vm.isBrowserDecidingDarkMode || _vm.isForcedLight },
                { 'hover-hover:dark:hover:text-canary-500': _vm.isBrowserDecidingDarkMode },
                { 'hover-hover:hover:text-canary-500': _vm.isForcedDark },
                // Active
                { 'hover-hover:active:text-grape-500': _vm.isBrowserDecidingDarkMode || _vm.isForcedLight },
                { 'hover-hover:dark:active:text-canary-500': _vm.isBrowserDecidingDarkMode },
                { 'hover-hover:active:text-canary-500': _vm.isForcedDark },

                // Focus
                { 'hover-hover:focus:text-grape-500': _vm.isBrowserDecidingDarkMode || _vm.isForcedLight },
                { 'hover-hover:dark:focus:text-canary-500': _vm.isBrowserDecidingDarkMode },
                { 'hover-hover:focus:text-canary-500': _vm.isForcedDark },

                // Disabled
                { 'disabled:text-dark-text-300': _vm.isBrowserDecidingDarkMode || _vm.isForcedLight },
                { 'dark:disabled:text-light-text-300': _vm.isBrowserDecidingDarkMode },
                { 'disabled:text-light-text-300': _vm.isForcedDark },

                { 'hover-hover:disabled:text-dark-text-300': _vm.isBrowserDecidingDarkMode || _vm.isForcedLight },
                { 'hover-hover:dark:disabled:text-light-text-300': _vm.isBrowserDecidingDarkMode },
                { 'hover-hover:disabled:text-light-text-300': _vm.isForcedDark } ]
            : []),
          (_vm.isColorDanger
            ? [
                'text-danger-100',
                'hover-hover:hover:text-scarlet-600',
                'hover-hover:active:text-scarlet-600',
                'hover-hover:focus:text-scarlet-600',
                // Disabled
                'hover-hover:disabled:text-scarlet-700',
                'hover-hover:dark:disabled:text-scarlet-700' ]
            : []),
          (_vm.isColorDanger
            ? [
                'text-danger-100',
                'hover-hover:hover:text-scarlet-600',
                'hover-hover:active:text-scarlet-600',
                'hover-hover:focus:text-scarlet-600',
                // Disabled
                'hover-hover:disabled:text-scarlet-700',
                'hover-hover:dark:disabled:text-scarlet-700' ]
            : []),
          (_vm.isColorActive ? ['text-grape-500', 'dark:text-canary-500'] : []) )
      : []) ),attrs:{"href":_vm.href,"role":_vm.role,"target":_vm.hrefTarget,"disabled":_vm.disabled},on:{"click":_vm.click,"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }return _vm.handleSpaceKey($event)}}},[(_vm.iconName)?_c('oz-icon',{attrs:{"font":_vm.iconFont,"name":_vm.iconName,"size":_vm.iconSize,"dir":_vm.dir}}):_vm._e(),_vm._v(" "),(_vm.hasText)?_c('div',{ref:"text",class:['font-sans', _vm.xTextPadding ? 'px-4' : 'px-0']},[_vm._t("default")],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }